import toArray from 'lodash/toArray';
import getRtcStatsReportAdapter from './get_rtc_stats_report_adapter';
import getShouldUseStandardGetStats from '../../helpers/shouldUseStandardGetStats';

const shouldUseStandardGetStats = getShouldUseStandardGetStats();

// This returns the array-ified list of stats our users are accustomed to
export default (peerConnection, completion) => {
  getRtcStatsReportAdapter(peerConnection, (err, rtcStatsReport) => {
    let stats = [];
    if (shouldUseStandardGetStats) {
      // Firefox <= 45 can't use rtcStatsReport.values OPENTOK-32755
      if (typeof rtcStatsReport.values === 'function') {
        stats = toArray(rtcStatsReport.values());
      } else if (typeof rtcStatsReport.forEach !== 'function') {
        stats = Object.keys(rtcStatsReport).map(key => rtcStatsReport[key]);
      } else {
        rtcStatsReport.forEach((rtcStats) => {
          stats.push(rtcStats);
        });
      }
    } else {
      rtcStatsReport.result().forEach((rtcStat) => {
        const stat = {};

        rtcStat.names().forEach((name) => {
          stat[name] = rtcStat.stat(name);
        });

        // fake the structure of the "new" RTC stat object
        stat.id = rtcStat.id;
        stat.type = rtcStat.type;
        stat.timestamp = rtcStat.timestamp;
        stats.push(stat);
      });
    }

    completion(null, stats);
  });
};
